module.exports = {"330105001":"米市巷街道","330105002":"湖墅街道","330105003":"小河街道","330105004":"和睦街道","330105005":"拱宸桥街道","330105007":"大关街道","330105008":"上塘街道","330105009":"祥符街道","330105010":"康桥街道","330105011":"半山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330105.json
// module id = 868
// module chunks = 0